import { useCallback, useContext } from 'react'
import { CreateSportsSeasonContext } from '../create/CreateSeason'
import { SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext';

export const useCreateSportsSeason = () => {

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};

  const createSportsSeasonContext = useContext(CreateSportsSeasonContext)
  const { createSportsSeason_state, createSportsSeason_handlers } = createSportsSeasonContext ?? {}

  function calculatePlayDatesForSection(numTeams) {
    if (numTeams < 2) return 0; // No play dates needed for fewer than 2 teams 
    const totalGames = (numTeams * (numTeams - 1)); // Total games needed for each team playing others twice
    const gamesPerPlayDate = Math.floor(numTeams / 2); // Maximum games per play date
    const playDates = Math.ceil(totalGames / gamesPerPlayDate); // Total play dates needed

    return playDates;
  }

  const getScheduleDatesInfo = useCallback(({ currentSectionCount, sectionDates }) => {
    const scheduleDates_info = {
      currentSectionCount,
      currentNeeded: calculatePlayDatesForSection(currentSectionCount),
      currentCount: sectionDates ? sectionDates.length : 0,
      currentDates: sectionDates,
    }
    scheduleDates_info.ready = scheduleDates_info?.currentCount === scheduleDates_info?.currentNeeded
    return scheduleDates_info;
  }, [createSportsSeason_state])

  const getSportsSeason = useCallback(() => {
    const {
      details_info,
    } = sportsSeason_state ?? {}

    const seasonals = {
      details: details_info?.details,
      playoffQualifyCounts: details_info?.playoffQualifyCounts
    }

    return { seasonals }
  }, [createSportsSeason_state])

  const getCreateSportsSeason = useCallback(() => {
    const {
      currentSeason_info,
      districtTeams,
      grid_info,
      mediaSeason,
      selectedItems,
      sportsData_info,
      sportsSeason_selected,
    } = createSportsSeason_state ?? {}

    const { seasonals } = sportsSeason_selected ?? {}
    const { teams } = seasonals ?? {}
    const sectionTeamCounts = groupTeamsByLevelsAndSections(teams)
    return {
      currentSeason_info,
      districtTeams,
      grid_info,
      mediaSeason,
      sectionTeamCounts,
      selectedItems,
      selectedItems,
      sportsData_info,
      sportsSeason_selected,
    }
  }, [createSportsSeason_state])

  const ammendSeasonalItem = useCallback(({ key, data }) => {
    createSportsSeason_handlers?.handleAmmend_ammendSeasonalItem(key, data);
  }, [createSportsSeason_state])

  return { getSportsSeason, getCreateSportsSeason, ammendSeasonalItem, getScheduleDatesInfo, createSportsSeason_state }

}

const groupTeamsByLevelsAndSections = (teams) => {
  // Group teams by level and then by section
  const groupedTeams = _.groupBy(teams, 'levels');
  const levels = _.mapValues(groupedTeams, (teamsInLevel) =>
    _.groupBy(teamsInLevel, 'sections')
  );

  const sectionCounts = [];

  // Iterate over levels and sections
  _.forEach(levels, (sections) => {
    _.forEach(sections, (teamsInSection) => {
      const numTeams = teamsInSection.length;
      // Add the number of teams to sectionCounts if it doesn't already exist
      if (!sectionCounts.includes(numTeams)) {
        sectionCounts.push(numTeams);
      }
    });
  });

  return sectionCounts.sort((a, b) => a - b);

};